import { Component } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { FilterStoreService } from 'src/app/services/filter-store.service';
import {
  ModalService,
  ObservableHandlerPair
} from 'src/app/services/modal.service';
import { PageIndexService } from 'src/app/services/page-index-service';
import { SignTitleAdjustmentPortalOverviewControllerRequestService } from './sign-title-adjustment-portal-overview-controller-request.service';
import {
  AbstractSignsPortalAssociationOverviewComponent,
  SIGN_ASSOCIATION_TYPE
} from '../abstract-signs-portal-association-overview.component';
import { SignPortalAssociation } from '../sign-portal-association';
import { SignTitleAdjustmentEditComponent } from '../../../sign-associations/edit-association/title/sign-title-adjustment-edit.component';
import { SignTitleAdjustment } from 'src/app/model/sign/title/sign-title-adjustment';
import { SignTitleAdjustmentControllerRequestService } from 'src/app/services/api/sign-associations/implementations/sign-title-adjustment-controller-request.service';
import { SignTitleAdjustmentOverview } from 'src/app/model/sign/title/sign-title-adjustment-overview';

@Component({
  selector: 'sign-title-adjustment-portal-overview',
  templateUrl: '../abstract-signs-portal-association-overview.component.html',
  styleUrls: ['../abstract-signs-portal-association-overview.component.scss']
})
export class SignTitleAdjustmentPortalOverviewComponent extends AbstractSignsPortalAssociationOverviewComponent<
  SignTitleAdjustment,
  SignTitleAdjustmentOverview
> {
  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected signTitleAdjustmentPortalOverviewControllerRequestService: SignTitleAdjustmentPortalOverviewControllerRequestService,
    protected signTitleAdjustmentControllerRequestService: SignTitleAdjustmentControllerRequestService,
    protected modalService: ModalService,
    protected _lightbox: Lightbox
  ) {
    super(
      filterStoreService,
      pageIndexService,
      signTitleAdjustmentPortalOverviewControllerRequestService,
      signTitleAdjustmentControllerRequestService,
      modalService,
      _lightbox,
      SIGN_ASSOCIATION_TYPE.SIGN_TITLE_ADJUSTMENT
    );
  }

  protected getLocalStorageKey(): string {
    return 'SignTitleAdjustmentPortalOverviewComponent';
  }

  public editItem(item: SignPortalAssociation): void {
    this.modalService.openComponentInModal(
      SignTitleAdjustmentEditComponent,
      [
        { key: 'signId', value: item.sign.id },
        { key: 'assocObject', value: item }
      ],
      new ObservableHandlerPair(
        modalRef => modalRef.componentInstance.saveSuccessEvent,
        (res: SignTitleAdjustment) => {
          if (res != null) {
            this.doLoadSubject.next();
          }
        }
      ),
      { width: '750px', maxHeight: '90vh' }
    );
  }
}
